import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'

import AppStore from '../../../common/app-store'

const Welcome: React.FunctionComponent = () => {
    const { t } = useTranslation('landing')
    const isMobile = useMediaQuery({
        query: '(max-width: 500px)'
    })

    const bgLarge = require('./images/bg.png')
    const bgWebPLarge = require('./images/bg.webp')

    const bgSmall = require('./images/bg_s.png')
    const bgWebPSmall = require('./images/bg_s.webp')

    return (
        <Container>
            <Picture>
                <source srcSet={ isMobile ? bgWebPSmall : bgWebPLarge + " 1x" } type="image/webp" />
                <Image src={ isMobile ? bgSmall : bgLarge } />
            </Picture>
            <Wrapper>
                <Caption>{t('welcome.caption')}</Caption>
                <Subcaption>{t('welcome.subcaption')}</Subcaption>
                <StoreContainer>
                    <AppStore />
                </StoreContainer>
            </Wrapper>

            <More>
                {t('welcome.more')}
                <ArrowDown src={require('./images/more.svg')}/>
            </More>
        </Container>
    )
}


const Container = styled.div`
    position: relative;

    width: 100%;
    height: 90vh;

    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;

    display: flex;
    justify-content: center;
    align-items: center;

    color: ${p => p.theme.colors.bg};
`

const Picture = styled.picture`
    position: absolute;

    height: 100%;

    top: 0;
    left: 50%;
    transform: translateX(-50%);

    z-index: 1;
`

const Image = styled.img`
    height: 100%;
`

const Wrapper = styled.div`
    display: grid;
    flex-direction: column;
    align-items: center;
    justify-items: center;

    max-width: 100%;

    grid-template-columns: 1fr;

    grid-row-gap: 16px;

    padding: 0 15px;

    z-index: 2;

    ${up('mobileBig')} {
        padding: 0 20px;
    }

    ${up('tablet')} {
        padding: 0 50px;

        grid-row-gap: 24px;
    }

    ${up('desktop')} {
        width: 850px;
    }
`

const Caption = styled.div`
    text-align: center;
    
    font-style: normal;
    font-weight: bold;
    font-size: 24px;

    ${up('mobileBig')} {
        font-size: 28px;    
    }

    ${up('tablet')} {
        font-size: 52px;    
    }
`

const Subcaption = styled.div`
    text-align: center;
    font-size: 14px;

    ${up('mobileBig')} {
        font-size: 20px;    
    }

    ${up('tablet')} {
        font-size: 20px;    
    }
`

const StoreContainer = styled.div`
    display: grid;
    justify-items: center;
`

const More = styled.div`
    position: absolute;
    bottom: 10%;

    display: flex;
    flex-direction: column;
    align-items: center;

    font-size: 12px;
    text-align: center;

    z-index: 2;
`

const ArrowDown = styled.img`
    margin-top: 6px;
    width: 5px;
`


export default Welcome